
import { defineComponent, ref } from "vue";
import { RouterLink, useRouter } from "vue-router";

import CategoryEntry from "./components/category-entry.vue";
import { Icon } from "./components/icons";
import ListingCard from "./components/listing-card.vue";
import SectionHeader from "./components/section-header.vue";
import { categories } from "./data/categories";
import { countByCategory, listingsByCategory } from "./data/query";
import { site } from "./data/site";
import common from "./styles/common.module.less";
import style from "./style.module.less";

// 首页每个分类区块最多展示 6 条（对齐参考站 6/3/2/2 的分布）
const HOME_LIMIT = 6;

export default defineComponent({
  name: "XiyouHome",
  setup() {
    const router = useRouter();
    const keyword = ref("");

    const search = () => {
      const q = keyword.value.trim();
      router.push({ name: "XiyouPortal", query: q ? { q } : {} });
    };

    return () => (
      <div class={common.shell}>
        <section class={style.hero}>
          <p class={style.kicker}>
            <Icon name="shield" />
            先审后发 · 分类信息
          </p>
          <h1 class={style.heroTitle}>{site.heroTitle}</h1>
          <p class={style.heroSubtitle}>{site.heroSubtitle}</p>
          <form
            class={[common.searchBox, style.searchForm]}
            onSubmit={(event: Event) => {
              event.preventDefault();
              search();
            }}
          >
            <input
              class={common.searchInput}
              value={keyword.value}
              placeholder="搜索信息 / 服务..."
              onInput={(event: Event) => {
                keyword.value = (event.target as HTMLInputElement).value;
              }}
            />
            <button class={common.searchBtn} type="submit">
              <Icon name="search" />
              搜索
            </button>
          </form>
          <div class={style.hints}>
            <span class={style.hint}>
              <Icon name="shield" />
              信息先审核后发布
            </span>
            <span class={style.hint}>
              <Icon name="filter" />共 {categories.length} 类分类信息
            </span>
          </div>
          <div class={style.cta}>
            <RouterLink
              class={[common.btn, common.btnPrimary, style.ctaBtn]}
              to={{ name: "XiyouPublish" }}
            >
              免费发布
            </RouterLink>
          </div>
        </section>

        <section class={style.entries}>
          {categories.map((category) => (
            <CategoryEntry
              key={category.slug}
              category={category}
              count={countByCategory(category.slug)}
            />
          ))}
        </section>

        {categories.map((category) => (
          <section key={category.slug} class={style.block}>
            <SectionHeader
              title={category.name}
              subtitle={`${countByCategory(category.slug)} 条信息`}
              moreTo={{
                name: "XiyouPortal",
                query: { category: category.slug },
              }}
            />
            <div class={common.grid}>
              {listingsByCategory(category.slug, HOME_LIMIT).map((item) => (
                <ListingCard key={item.id} listing={item} />
              ))}
            </div>
          </section>
        ))}
      </div>
    );
  },
});
